<mat-calendar
  blazeClickable
  [selected]="selected"
  [dateFilter]="dateFilter"
  [dateClass]="dateClass"
  (selectedChange)="onSelectedChange($event)"
  (monthSelected)="onSelectedChange($event)"
/>
